import { render, staticRenderFns } from "./CategoriesAndProductsSidebarMenu.vue?vue&type=template&id=11ed255e&scoped=true&"
import script from "./CategoriesAndProductsSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./CategoriesAndProductsSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesAndProductsSidebarMenu.vue?vue&type=style&index=0&id=11ed255e&scoped=true&lang=css&"
import style1 from "./CategoriesAndProductsSidebarMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed255e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ed255e')) {
      api.createRecord('11ed255e', component.options)
    } else {
      api.reload('11ed255e', component.options)
    }
    module.hot.accept("./CategoriesAndProductsSidebarMenu.vue?vue&type=template&id=11ed255e&scoped=true&", function () {
      api.rerender('11ed255e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/CategoriesAndProductsSidebarMenu.vue"
export default component.exports